import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  AuthPageContainer,
  FormSection,
  FormContainer,
  FormTitle,
  InputGroup,
  Label,
  Input,
  SubmitButton,
  Message,
  BackButton,
} from "../components/auth/DashboardAuthStyles";
import AuthWelcomePanel from "../components/auth/AuthWelcomePanel";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { api } from "../services/api";

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setMessage("");
    setIsLoading(true);

    try {
      await api.auth.resetPassword(email);
      setMessage("Password reset instructions have been sent to your email.");
      setTimeout(() => {
        navigate("/login");
      }, 3000);
    } catch (err) {
      setMessage("An error occurred. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <AuthPageContainer data-testid="forgot-password-page">
      <AuthWelcomePanel />
      <FormSection>
        <FormContainer>
          <BackButton onClick={() => navigate("/login")} data-testid="forgot-password-back-button">
            <ArrowBackIcon /> Back to Login
          </BackButton>
          <FormTitle>Forgot Password</FormTitle>
          <form onSubmit={handleSubmit}>
            <InputGroup>
              <Label htmlFor="email">Admin Email</Label>
              <Input
                id="email"
                type="email"
                placeholder="Enter admin email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                data-testid="forgot-password-email-input"
              />
            </InputGroup>

            {message && (
              <Message isError={message.toLowerCase().includes("failed")}>
                {message}
              </Message>
            )}

            <SubmitButton type="submit" disabled={isLoading} data-testid="forgot-password-submit-button">
              {isLoading ? "Sending..." : "Send Reset Instructions"}
            </SubmitButton>
          </form>
        </FormContainer>
      </FormSection>
    </AuthPageContainer>
  );
};

export default ForgotPassword;
